import Vue from 'vue';
import Vuex from 'vuex';
import { aplicarIdioma, idiomaInicial, idiomasDaLoja, salvarEscolha } from '@/i18n';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        usuario: {},
        cliente: {},
        navigator: {},
        currentProduct: null,
        cart: [],
        grupos: [],
        produtos: [],
        configuracoes: {},
        ads: null,
        mesa: null,
        cupom: null,
        orderBump: [],
        bannerDisplayed: false,
        isInitialized: false,
        cardPaymentLoading: false,
        pedido: null,
        tablet: null,
        tabletOffline: false,
        relogio: Date.now(),
        idioma: null,
    },

    getters: {
        getNavigator: state => {
            return state.navigator;
        },

        getCurrentProduct: state => {
            return state.currentProduct;
        },

        getCart: state => {
            return state.cart;
        },

        getBannerDisplayed: state => {
            return state.bannerDisplayed;
        },

        getAds: state => {
            return state.ads;
        },

        getMesa: state => {
            return state.mesa;
        },

        getCupom: state => {
            return state.cupom;
        },

        getUsuario: state => {
            return state.usuario;
        },
    },

    mutations: {
        setNavigator(state, payload) {
            state.navigator = payload;
        },

        setCurrentProduct(state, payload) {
            state.currentProduct = payload;
        },

        setCart(state, payload) {
            state.cart = payload;
        },

        addToCart(state, payload) {
            state.cart.push(payload);
            localStorage.setItem('cart', JSON.stringify(state.cart));
        },

        setBannerDisplayed(state, payload) {
            state.bannerDisplayed = payload;
        },

        setAds(state, payload) {
            state.ads = payload;
        },

        setMesa(state, payload) {
            state.mesa = payload;
        },

        setCupom(state, payload) {
            state.cupom = payload;
        },

        setInitialized(state, payload) {
            state.isInitialized = !!payload;
        },

        setCardPaymentLoading(state, payload) {
            state.cardPaymentLoading = !!payload;
        },

        setUsuario(state, payload) {
            state.usuario = payload;
        },

        setOrderBump(state, payload) {
            state.orderBump = payload;
        },

        setTablet(state, payload) {
            state.tablet = payload;
        },

        setTabletOffline(state, payload) {
            state.tabletOffline = payload;
        },

        setPedido(state, payload) {
            state.pedido = payload;
        },

        setRelogio(state, payload) {
            state.relogio = payload;
        },

        setIdioma(state, payload) {
            state.idioma = payload;
        },
    },

    actions: {
        setAppData({ state: st, dispatch }, params) {
            st.grupos = params.grupos;
            st.produtos = params.produtos;
            st.configuracoes = params.configuracoes;

            st.isInitialized = true;

            dispatch('definirIdioma', idiomaInicial(params.configuracoes));
        },

        /** Aplica o idioma no cardápio, nas datas e nas chamadas à API. */
        definirIdioma({ commit, state: st }, idioma) {
            const oferecidos = idiomasDaLoja(st.configuracoes);
            const aplicado = aplicarIdioma(oferecidos.includes(idioma) ? idioma : oferecidos[0]);

            commit('setIdioma', aplicado);

            const http = Vue.prototype.$http;
            http && (http.defaults.headers.common['X-Idioma'] = aplicado);
        },

        escolherIdioma({ dispatch }, idioma) {
            salvarEscolha(idioma);
            dispatch('definirIdioma', idioma);
        },

        async userAuthenticate({ state: st }) {
            if (st.usuario?.id) {
                return;
            }

            const http = Vue.prototype.$http;

            try {
                const { data } = await http.post('get-auth');
                st.usuario = data.data.user;
                st.cliente = data.data.cliente;
            } catch (e) {
                if (e?.response?.status === 401) {
                    const emp = http.defaults.headers.common['emp'];
                    emp && localStorage.removeItem(`${emp}-access-token`);
                    delete http.defaults.headers.common['Authorization'];
                }

                console.log(e)
            }
        },

        logout({ state: st }) {
            st.usuario = {};
            st.cliente = {};
        },
    },

    modules: {
        //
    },
});
